import { client } from 'api/baseApi.ts';
import { dataApiHandler } from 'api/handlers/apiHandler.ts';
import { charactersEndpoints } from 'api/rtk-endpoints/CharactersEndpoints.ts';
import { AssetType } from 'api/services/AssetsService';
import { APIConfigData } from 'core/config/APIConfigData';
import { UploadAssetActions } from 'core/constants/enums/UploadAssetActionsEnum.ts';
import { captureDatadogErrors } from 'core/utils/datadogUtil';

export const getAllCharacters = (
	type = '',
	page = 1,
	pageSize = APIConfigData.CHARACTERS_PAGE_SIZE,
	{ dispatch, forceRefetch } = {
		dispatch: () => {},
		forceRefetch: false,
	},
) => {
	return dataApiHandler({
		endpoint: charactersEndpoints.endpoints.getCharacters.initiate,
		args: { type, page, pageSize },
		dispatch,
		forceRefetch,
	});
};
// new Promise((resolve, reject) => {
// 	axios({
// 		method: 'GET',
// 		url: `${APIConfigData.RENDERNET_BASE_URL}/v1/characters`,
// 		params: {
// 			page,
// 			page_size: pageSize,
// 			...(type !== '' && { type }),
// 		},
// 		headers: { 'Content-Type': 'application/json' },
// 	})
// 		.then((res) => {
// 			const { data, pagination } = res.data;
// 			resolve({ data, pagination });
// 		})
// 		.catch((error) => {
// 			reject(error?.response?.data?.err);
// 		});
// });

export function fetchUsers(query, callback) {
	if (!query) return;
	client.characters
		.search(query)
		.then((res) =>
			res?.data?.map((user) => ({
				display: user.name,
				id: `${user.id}@${user.input_image}@${user.character_type}`,
			})),
		)
		.then((data) => callback(data))
		.catch((err) => captureDatadogErrors('Error while fetching users', err));
}

export const updateCharacterService = (characterData, characterId, { dispatch }) => {
	const { name, image, prompt, features, characterType } = characterData;
	const request = {
		name,
		input_image: image,
		prompt,
		features: features
			? {
					age: features?.age,
					gender: features?.gender,
				}
			: null,
		character_type: characterType,
	};
	return dataApiHandler({
		endpoint: charactersEndpoints.endpoints.updateCharacter.initiate,
		args: { characterId, request },
		dispatch,
	});
};

export const createNewCharacterService = (characterData, { dispatch }) => {
	const { name, image, prompt, features, characterType } = characterData;
	const { age, gender, bodyType, ageNumber, hairColor, hairStyle, ethnicity, hairType } =
		features ?? {};
	const request = {
		name,
		input_image: image,
		prompt,
		...(features && {
			features: {
				age,
				gender,
				ethnicity,
				body_type: bodyType,
				age_number: ageNumber,
				hair_style: hairStyle,
				hair_type: hairType,
				hair_color: hairColor,
			},
		}),
		character_type: characterType,
	};
	return dataApiHandler({
		endpoint: charactersEndpoints.endpoints.createCharacter.initiate,
		args: { request },
		dispatch,
	});
};

export const deleteCharacterService = (characterIds, { dispatch }) => {
	return dataApiHandler({
		endpoint: charactersEndpoints.endpoints.deleteCharacter.initiate,
		args: { characterIds },
		dispatch,
	});
};

export const convertBase64ImageToFile = (base64Image) =>
	new Promise((resolve) => {
		const byteString = atob(base64Image.split(',')[1]);
		const mimeString = base64Image.split(',')[0].split(':')[1].split(';')[0];
		const ab = new ArrayBuffer(byteString.length);
		const ia = new Uint8Array(ab);
		for (let i = 0; i < byteString.length; i += 1) {
			ia[i] = byteString.charCodeAt(i);
		}
		const blob = new Blob([ab], { type: mimeString });
		resolve(blob);
	});

export const uploadCharacterImageAssetService = (imageBinary, { width, height, type }) =>
	new Promise((resolve, reject) => {
		const request = {
			type: AssetType.IMAGE,
			metadata: {
				dim: {
					width,
					height,
				},
				ext: type?.split('/')?.[1],
			},
			tag: UploadAssetActions.CHARACTER_STUDIO,
		};
		client.assets
			.upload(imageBinary, type ?? 'image/png', request)
			.then((res) => {
				const { data: asset } = res;
				if (asset.url?.length) {
					resolve({ image: asset.url, asset });
				} else {
					reject(new Error('Failed to upload character image'));
				}
			})
			.catch((error) => {
				reject(error?.response?.data.err);
			});
	});

export const generateCharacterService = async (characterPrompt) => {
	return client.characters.generate([{ txt_to_character: { character_prompt: characterPrompt } }]);
};

export const getCharacterDescriptionService = async (assetId) => {
	const request = [
		{
			generation_type: 'character_description',
			character_description: {
				asset_id: assetId,
			},
		},
	];
	return client.characters.generate(request);
};
